__webpack_require__.p = "/wheel-spin/";